angular
    .module('app')
    .component('gamesAdd', {
        templateUrl: '/templates/pages/games/gamesAdd/gamesAdd.html',
        controller: 'GamesAddController',
        controllerAs: 'vm',
    });